import React from 'react'
import translator from 'i18next'
import BraftEditor from 'braft-editor'
import { map } from 'lodash'
import { Form, Skeleton } from 'antd'

const FormEditor = props => {
    const {
        onChange,
        name,
        schema = {},
        formitemprops = {},
        loading = false,
        display = false,
    } = props

    const handleChange = value => {
        if (name && onChange) {
            onChange(name, value)
        }
    }

    let Component = (
        <>
            <strong>{translator.t(props.text)}&nbsp;</strong>
            <BraftEditor
                {...props}
                className={`form-editor ${props.className || ''}`}
                language='en'
                onChange={handleChange}
            />
        </>
    )
    let formProps = {}

    if (name && schema[name]) {
        const fieldSchema = schema[name]
        const label = props.text || fieldSchema.label

        Component = (
            <BraftEditor
                {...props}
                language='en'
                className={`form-editor ${props.className || ''}`}
                onChange={handleChange}
            />
        )
        formProps = {
            name,
            label: translator.t(label),
            rules: map(fieldSchema.rules, rule => ({
                ...rule,
                message: translator.t(rule.message),
            })),
            initialvalue: '',
        }
    }

    if (loading) Component = <Skeleton.Input active />
    if (display)
        Component = (
            <>
                <div className='ql-editor'>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: props.value,
                        }}
                    />
                </div>
            </>
        )

    return (
        <Form.Item className='form-item' {...formProps} {...formitemprops}>
            {Component}
        </Form.Item>
    )
}

// TODO remove this once rename warning on BraftEditor updated
console.warn = () => {}
export default FormEditor
